import {useCustomizationHelpers, customizationHelpers} from '~~/layers/core/app/composables/customization-helpers'

// Hide the search form on homepage for unauthenticated users and supplier-role users only
const isShowMainPageFormWrapper = computed(() => {
    // Hide for guest users (unauthenticated)
    if (authStore.isGuest) {
        return false
    }

    // Hide for supplier-role users
    if (authStore.isSupplier) {
        return false
    }

    // Show for all other authenticated users
    return true
})

customizationHelpers.isShowMainPageFormWrapper = isShowMainPageFormWrapper
customizationHelpers.forceIncludeInFee = true

export {useCustomizationHelpers}
